import { memo } from "react";

import { Button } from "@components/Button";
import { tw } from "classnames";

type Props = {
  adjacentCollection: {
    handle: string;
    id: string;
    title: string;
  };
  handleAdjacentCollectionButtonClick: () => void;
  isActive: boolean;
};

const styles = {
  base: tw("shrink-0"),
};

const CollectionAdjacentCollectionButtonViewBase = ({
  adjacentCollection,
  handleAdjacentCollectionButtonClick,
  isActive,
}: Props) => {
  return (
    <Button
      className={styles.base}
      key={adjacentCollection.id}
      onClick={handleAdjacentCollectionButtonClick}
      size="small"
      type={isActive ? "quaternary-alt" : "quaternary"}
    >
      {adjacentCollection.title}
    </Button>
  );
};

export const CollectionAdjacentCollectionButtonView = memo(
  CollectionAdjacentCollectionButtonViewBase
);
